import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(token) {
    if (this.socket && this.socket.connected) {
      return;
    }

    // Connect to Socket.IO server
    this.socket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000', {
      query: { token },
      transports: ['websocket', 'polling']
    });

    // Connection events
    this.socket.on('connect', () => {
      console.log('Socket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('error', (error) => {
      console.error('Socket error:', error);
    });

    // Restore listeners
    this.listeners.forEach((handler, event) => {
      this.socket.on(event, handler);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event, handler) {
    const wrappedHandler = (data) => {
      console.log(`📥 Socket event received: ${event}`, data);
      handler(data);
    };
    this.listeners.set(event, wrappedHandler);
    if (this.socket) {
      this.socket.on(event, wrappedHandler);
    }
  }

  off(event) {
    this.listeners.delete(event);
    if (this.socket) {
      this.socket.off(event);
    }
  }

  emit(event, data) {
    if (this.socket && this.socket.connected) {
      this.socket.emit(event, data);
    } else {
      console.warn('Socket not connected');
    }
  }

  // Message events
  sendMessage(receiverId, content, attachmentData = null) {
    console.log('🚀 Sending message via socket:', { receiverId, content });
    this.emit('new_message', {
      receiver_id: receiverId,
      content,
      ...attachmentData
    });
  }

  markAsRead(senderId) {
    console.log('🚀 Marking messages as read via socket:', { senderId });
    this.emit('mark_as_read', { sender_id: senderId });
  }

  startTyping(receiverId) {
    console.log('🚀 Sending typing event via socket:', { receiverId });
    this.emit('typing', { receiver_id: receiverId });
  }

  stopTyping(receiverId) {
    console.log('🚀 Sending stop_typing event via socket:', { receiverId });
    this.emit('stop_typing', { receiver_id: receiverId });
  }
}

// Singleton instance
const socketService = new SocketService();
export default socketService;
